import { useEffect } from 'react';

import { useSession } from '@eneco/auth';
import env from '@eneco/common/env';
import { InferGetServerSidePropsType, useRouter } from '@eneco/next';
import { NEXT_LOCALE_COOKIE } from '@eneco/next/constants';
import { getServerCookie } from '@eneco/next/server/utils/cookies';
import type { GetServerSidePropsContext } from 'next';
import { signIn } from 'next-auth/react';

import { ALLOWED_LOCALE } from '../server/proxy/constants';

export const getServerSideProps = ({ req }: GetServerSidePropsContext) => {
  const feHost = env('FE_HOST');
  const locale = getServerCookie(req, NEXT_LOCALE_COOKIE) ?? 'nl';

  return { props: { feHost, locale } };
};

const LoginPage = ({ feHost, locale }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const { isReady, query, push, locale: urlLocale } = useRouter();

  const { data: session } = useSession();

  const language = ALLOWED_LOCALE.includes(urlLocale) ? urlLocale : locale;

  useEffect(() => {
    if (!isReady) return;

    const callbackUrl = (query?.returnUrl as string) || '/my-eneco/dashboard';

    if (session) {
      push(`${feHost}${callbackUrl}`);
    } else {
      signIn('okta', { callbackUrl }, { language });
    }
  }, [isReady, query, push, feHost, session, language]);

  return null;
};

export default LoginPage;
